import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PremiumSidebar from "./PremiumSidebar";
import { profileAvatar } from "../component/ImageList";
import stringsoflanguages from "../component/stringsoflanguages";
import baseURL from "../component/baseURL";

const PREMIUM_SIDEBAR_PATHS = {
    "Premium Members": "/premium-home/premium-members",
    "Consumer Apps Active": "/premium-home/consumer-apps-active",
    "Consumer App Settings": "/premium-home/consumer-app-settings",
    "Info Requests": "/premium-home/info-requests",
    "Custom App Store": "/premium-home/custom-app-store",
};

function normalizeDisplayValue(value) {
    if (value == null) return "";
    const normalized = String(value).trim();
    if (!normalized) return "";
    const lowered = normalized.toLowerCase();
    if (lowered === "null" || lowered === "undefined") return "";
    return normalized;
}

export default function ConsumerList() {
    const navigate = useNavigate();
    const location = useLocation();
    const consumer = location.state?.consumer_details || {};
    const [allPortfolio, setAllPortfolio] = useState([]);

    const [activeItem] = useState(() => location.state?.premiumSidebarActive || "Consumer Apps Active");
    const [isMobilePageOpen, setIsMobilePageOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [gearMenuOpen, setGearMenuOpen] = useState(false);
    const [gearSpinning, setGearSpinning] = useState(false);
    const gearMenuRef = useRef(null);

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 767);
        };
        checkMobile();
        window.addEventListener("resize", checkMobile);
        return () => window.removeEventListener("resize", checkMobile);
    }, []);

    useEffect(() => {
        if (window.innerWidth <= 767) {
            setIsMobilePageOpen(true);
        }
    }, []);

    useEffect(() => {
        document.body.classList.add("premium-page");
        return () => {
            document.body.classList.remove("premium-page");
        };
    }, []);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (gearMenuRef.current && !gearMenuRef.current.contains(e.target)) {
                setGearMenuOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        const userid = localStorage.getItem('user_id');
        const consumerId = localStorage.getItem('consumer_id');
        fetchDetailsAPI(userid, consumerId);
    }, []);


    function fetchDetailsAPI(userid, consumerId) {
        console.log(consumerId)
        let formdata = new FormData();
        formdata.append("agent_id", userid)
        formdata.append("consumer_id", consumerId)
        formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055")
        console.log(formdata)
        fetch(baseURL.URL + '/consumers/consumer_listing', {
            method: 'POST',
            body: formdata
        }).then((response) => response.json())
            .then((responseJson) => {
                const result = responseJson.response.portfolios
                console.log('result')
                console.log(result)
                if (responseJson.server.code === 200) {
                    setAllPortfolio(result)
                    // console.log(responseJson.response.portfolio)
                }
                else {
                    Alert.alert(responseJson.server.message)
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }

    const handleItemClick = (item) => {
        window.dispatchEvent(
            new CustomEvent("premiumMembersView", {
                detail: { isViewing: item === "Premium Members" },
            })
        );
        const path = PREMIUM_SIDEBAR_PATHS[item] || "/premium-home/premium-members";
        navigate(path);
    };

    const navigateBackToPremiumSection = () => {
        window.dispatchEvent(
            new CustomEvent("premiumMembersView", {
                detail: { isViewing: activeItem === "Premium Members" },
            })
        );
        const path = PREMIUM_SIDEBAR_PATHS[activeItem] || "/premium-home/consumer-apps-active";
        navigate(path);
    };

    const handleBackClick = () => {
        navigateBackToPremiumSection();
    };

    function openConsumerListFilter() {
        navigate("/premium-home/consumer-filter", {
            state: {
                premiumSidebarActive: activeItem,
                consumer_details: consumer,
                consumer_id: location.state?.consumer_id,
                consumer_name: location.state?.consumer_name,
            },
        });
    }

    const firstName = normalizeDisplayValue(consumer?.fname);
    const lastName = normalizeDisplayValue(consumer?.lname);
    const fullName = `${firstName} ${lastName}`.trim() || "N/A";
    const email = normalizeDisplayValue(consumer?.email) || "N/A";
    const phone = normalizeDisplayValue(consumer?.phone) || "N/A";
    const state = normalizeDisplayValue(consumer?.state_name);
    const city = normalizeDisplayValue(consumer?.city_name);
    const country = normalizeDisplayValue(consumer?.country_name);
    const locationText = [city, country].filter(Boolean).join(" - ") || "N/A";
    const favCount = normalizeDisplayValue(consumer?.fav_count) || "0";
    const imageUrl = normalizeDisplayValue(consumer?.picture) || profileAvatar;


    return (
        <>
        <section className="home">
            <div className="container">
                <div className="content-holder">
                    <PremiumSidebar activeItem={activeItem} setActiveItem={handleItemClick} />
                    <div className={`content-right-wrapper ${isMobilePageOpen ? "mobile-page-open" : ""}`}>
                        {isMobile && isMobilePageOpen && (
                            <div className="mobile-page-header">
                                <button type="button" className="mobile-back-btn" onClick={handleBackClick}>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                    >
                                        <path
                                            d="M15 18L9 12L15 6"
                                            stroke="white"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                    Back
                                </button>
                                <h2 className="mobile-page-title">Consumer profile</h2>
                            </div>
                        )}
                        <div className={`content-right${isMobile ? " feed-recived-page-mobile" : ""}`}>
                            <div className="search-filter-section">
                                <button
                                    type="button"
                                    className="filter-btn"
                                    onClick={() => navigateBackToPremiumSection()}
                                >
                                    Back
                                </button>
                            </div>


                            <div className="members-profile-container consumer-profile-container">
                                <div className="members-profile-header consumer-profile-header">

                                    <div className="members-profile-image-wrapper">
                                        <img
                                            className="members-profile-image"
                                            src={imageUrl || profileAvatar}
                                            alt={`${firstName} ${lastName}`}
                                        />

                                    </div>
                                    <div className="members-profile-info">
                                        <h3 className="members-profile-name">{firstName} {lastName}</h3>
                                        <p className="members-profile-email font-medium">{email}</p>
                                        {/* <p className="member-since mb-0">Member since {membersProfile?.added_date}</p> */}
                                        {/* <p className="members-profile-title">{Title}</p> */}
                                        {/* <p className="members-profile-location">{[city, country].filter(Boolean).join(' - ')}</p> */}
                                        <div className="members-profile-contact-btns">
                                            <Link to={`tel:${phone}`} className="members-profile-contact-btn" aria-label="Call">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#7323ff" strokeWidth="2">
                                                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                                                </svg>
                                            </Link>
                                            <Link to={`mailto:${email}`} className="members-profile-contact-btn" aria-label="Email">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#7323ff" strokeWidth="2">
                                                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                                                    <polyline points="22,6 12,13 2,6" />
                                                </svg>
                                            </Link>
                                            <Link to={`sms:${phone}`} className="members-profile-contact-btn" aria-label="Message">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#7323ff" strokeWidth="2">
                                                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                                                </svg>
                                            </Link>
                                        </div>
                                    </div>
                                </div>

                                <div className="profile-details">
                                    <div className="detail-section">
                                        <h3 className="section-title">{stringsoflanguages.personalInformation}</h3>
                                        <div className="detail-content">
                                            <div className="detail-row">
                                                <div className="detail-label">{stringsoflanguages.fName}</div>
                                                <div className="detail-value">{firstName}</div>
                                            </div>
                                            <div className="detail-row">
                                                <div className="detail-label">{stringsoflanguages.lName}</div>
                                                <div className="detail-value">{lastName}</div>
                                            </div>
                                            <div className="detail-row">
                                                <div className="detail-label">{stringsoflanguages.phone}</div>
                                                <div className="detail-value">{phone}</div>
                                            </div>
                                            <div className="detail-row">
                                                <div className="detail-label">{stringsoflanguages.country}</div>
                                                <div className="detail-value">{country}</div>
                                            </div>
                                            <div className="detail-row">
                                                <div className="detail-label">{stringsoflanguages.state}</div>
                                                <div className="detail-value">{state}</div>
                                            </div>
                                            <div className="detail-row">
                                                <div className="detail-label">{stringsoflanguages.city}</div>
                                                <div className="detail-value">{city}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            {!isMobile && (
                                <div className="btn-section btn-section-gear" ref={gearMenuRef}>
                                    <button
                                        type="button"
                                        className={`btn-primary gear-btn ${gearSpinning ? "gear-spin" : ""}`}
                                        onClick={() => {
                                            setGearMenuOpen((prev) => !prev);
                                            setGearSpinning(true);
                                            setTimeout(() => setGearSpinning(false), 500);
                                        }}
                                        aria-label="Options"
                                        aria-expanded={gearMenuOpen}
                                    >
                                        <i className="fa-solid fa-gear"></i>
                                    </button>
                                    {gearMenuOpen && (
                                        <ul className="gear-dropdown" aria-label="Options list">
                                            <li>
                                                <button
                                                    type="button"
                                                    className="gear-dropdown-item"
                                                    onClick={() => {
                                                        setGearMenuOpen(false);
                                                        openConsumerListFilter();
                                                    }}
                                                >
                                                    <i className="fa-solid fa-sliders"></i>
                                                    <span>{stringsoflanguages.filter}</span>
                                                </button>
                                            </li>
                                        </ul>
                                    )}
                                </div>
                            )}

                            {isMobile && (
                                <nav
                                    className="mobile-bottom-nav liquidGlass-wrapper dock feed-recived-mobile-bottom-nav consumer-list-footer-nav"
                                    aria-label="Consumer list actions"
                                >
                                    <div className="liquidGlass-effect" aria-hidden="true" />
                                    <div className="liquidGlass-shine" aria-hidden="true" />
                                    <div
                                        className="mobile-nav-item"
                                        role="button"
                                        tabIndex={0}
                                        aria-label={stringsoflanguages.filter}
                                        onClick={openConsumerListFilter}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter" || e.key === " ") {
                                                e.preventDefault();
                                                openConsumerListFilter();
                                            }
                                        }}
                                    >
                                        <i className="fa-solid fa-sliders" aria-hidden="true" />
                                    </div>
                                </nav>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>
            <svg style={{ display: "none" }} aria-hidden="true">
                <filter id="glass-distortion-consumer-list" x="0%" y="0%" width="100%" height="100%" filterUnits="objectBoundingBox">
                    <feTurbulence type="fractalNoise" baseFrequency="0.01 0.01" numOctaves="1" seed="5" result="turbulence" />
                    <feComponentTransfer in="turbulence" result="mapped">
                        <feFuncR type="gamma" amplitude="1" exponent="10" offset="0.5" />
                        <feFuncG type="gamma" amplitude="0" exponent="1" offset="0" />
                        <feFuncB type="gamma" amplitude="0" exponent="1" offset="0.5" />
                    </feComponentTransfer>
                    <feGaussianBlur in="turbulence" stdDeviation="3" result="softMap" />
                    <feSpecularLighting in="softMap" surfaceScale="5" specularConstant="1" specularExponent="100" lightingColor="white" result="specLight">
                        <fePointLight x="-200" y="-200" z="300" />
                    </feSpecularLighting>
                    <feComposite in="specLight" operator="arithmetic" k1="0" k2="1" k3="1" k4="0" result="litImage" />
                    <feDisplacementMap in="SourceGraphic" in2="softMap" scale="150" xChannelSelector="R" yChannelSelector="G" />
                </filter>
            </svg>
        </>
    );
}
